import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  gap: 0.85rem;
  padding: 1rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  &:last-child {
    border-bottom: none;
  }

  ${({ $nested, theme }) =>
    $nested &&
    `
    margin-left: 1.75rem;
    padding-left: 1rem;
    border-left: 2px solid ${theme.colors.border};
  `}
`;

const Avatar = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 9999px;
  background: ${({ theme }) => theme.colors.primary}22;
  color: ${({ theme }) => theme.colors.primary};
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 0.95rem;
  flex-shrink: 0;
`;

const Body = styled.div`
  min-width: 0;
  flex: 1;
`;

const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.65rem;
  margin-bottom: 0.35rem;
`;

const Name = styled.strong`
  font-size: 0.9375rem;
  color: ${({ theme }) => theme.colors.foreground};
`;

const DateText = styled.time`
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.colors.mutedForeground};
`;

const Text = styled.div`
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.65;
  color: ${({ theme }) => theme.colors.foreground};
  white-space: pre-wrap;
  word-break: break-word;

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

const ReplyBtn = styled.button`
  margin-top: 0.5rem;
  padding: 0;
  border: none;
  background: none;
  font-size: 0.8125rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const Replies = styled.div`
  margin-top: 0.25rem;
`;

function formatCommentDate(value) {
  if (!value) return '';
  return new Date(value).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

function CommentRow({ comment, nested, onReply }) {
  const initial = (comment.authorName || '?').charAt(0).toUpperCase();

  return (
    <Wrap $nested={nested}>
      <Avatar aria-hidden="true">{initial}</Avatar>
      <Body>
        <Meta>
          <Name>{comment.authorName}</Name>
          <DateText dateTime={comment.createdAt}>{formatCommentDate(comment.createdAt)}</DateText>
        </Meta>
        <Text dangerouslySetInnerHTML={{ __html: comment.body }} />
        {!nested && onReply ? (
          <ReplyBtn type="button" onClick={() => onReply(comment)}>
            Reply
          </ReplyBtn>
        ) : null}
      </Body>
    </Wrap>
  );
}

export default function CommentItem({ comment, onReply }) {
  return (
    <div>
      <CommentRow comment={comment} onReply={onReply} />
      {comment.replies?.length > 0 && (
        <Replies>
          {comment.replies.map((reply) => (
            <CommentRow key={reply._id} comment={reply} nested />
          ))}
        </Replies>
      )}
    </div>
  );
}
